export default __webpack_public_path__ + "static/artinov-698386718ebbddcdcc1362050c784578.png";